import React, { useState } from 'react';
import { 
  HeartHandshake, 
  ShieldCheck, 
  CheckCircle2, 
  Lock, 
  Users, 
  FileText,
  AlertTriangle,
  Info
} from 'lucide-react';

export const DigitalEstatePage: React.FC = () => {
  const [steps, setSteps] = useState([
    { id: 'adns', title: 'Register with Australian Death Notification Service (ADNS)', done: false, desc: 'Single national notification portal to close accounts across banks, telcos, and energy providers.' },
    { id: 'apple_legacy', title: 'Designate Apple Legacy Contact / Inactive Google Manager', done: false, desc: 'Allows trusted executors to inherit photos and documents without knowing master passwords.' },
    { id: 'pw_emergency', title: 'Store Emergency Password Manager Recovery Kit in Home Safe', done: false, desc: 'Paper backup of master recovery key and 2FA seed stored alongside physical will.' },
    { id: 'super_binding', title: 'Lodge Binding Death Benefit Nomination with Super Fund', done: false, desc: 'Ensures superannuation balances bypass probate delays and reach intended beneficiaries directly.' }
  ]);

  const toggle = (id: string) => {
    setSteps(prev => prev.map(s => s.id === id ? { ...s, done: !s.done } : s));
  };

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-8">
      <div className="text-center space-y-2">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-950 text-emerald-300 text-xs font-bold border border-emerald-800">
          <HeartHandshake className="w-3.5 h-3.5" />
          <span>AUSTRALIAN DIGITAL SUCCESSION & ESTATE DEFENCE</span>
        </div>
        <h1 className="text-3xl font-extrabold text-white">Digital Estate & Inactive Account Succession Protocol</h1>
        <p className="text-xs text-slate-400 max-w-xl mx-auto">
          Prevent post-mortem identity theft and protect your digital assets with Australian Death Notification Service (ADNS) integration protocols.
        </p>
      </div>

      <div className="bg-slate-900 border border-slate-800 rounded-3xl p-6 sm:p-8 space-y-6 shadow-xl text-xs">
        <h3 className="font-bold text-white text-sm uppercase tracking-wider">Digital Estate Hardening Checklist:</h3>

        <div className="space-y-3">
          {steps.map((s) => (
            <div
              key={s.id}
              onClick={() => toggle(s.id)}
              className={`p-4 rounded-2xl border cursor-pointer transition-all flex items-start gap-3.5 ${
                s.done 
                  ? 'bg-emerald-950/40 border-emerald-600 text-emerald-200' 
                  : 'bg-slate-950 border-slate-800 text-slate-300 hover:border-slate-700'
              }`}
            >
              <input type="checkbox" checked={s.done} readOnly className="mt-0.5 accent-emerald-500" />
              <div>
                <div className="font-bold text-white text-sm">{s.title}</div>
                <p className="text-slate-400 text-xs mt-0.5">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
